import React, {
  createContext,
  useState,
  Dispatch,
  SetStateAction,
  useContext,
  ReactNode,
} from "react";
import AlertTitle from "../../feedback/AlertTitle";
import Dialog from "../../dialogs/Dialog";
import Alert, { AlertProps } from "../../feedback/Alert";

const noop = () => {};
const UIContext = createContext<UIContextProps>({
  setAlert: noop,
  subdomain: "",
  setSubdomain: noop,
});

export interface AlertParams {
  isShown: boolean;
  severity?: AlertProps["severity"];
  message?: string;
  description?: string;
}

interface UIContextProps {
  setAlert: Dispatch<SetStateAction<AlertParams>>;
  subdomain: string;
  setSubdomain: Dispatch<SetStateAction<string>>;
}

type UIContextProviderProps = {
  children: ReactNode;
};

export const useUIContext = () => useContext(UIContext);

export const UIContextProvider: React.FC<UIContextProviderProps> = ({
  children,
}) => {
  const [alert, setAlert] = useState<AlertParams>({
    isShown: false,
    severity: "error",
    message: "",
  });

  const handleClose = () => {
    setAlert((prev) => ({ ...prev, isShown: false }));
  };

  const [subdomain, setSubdomain] = useState("");

  return (
    <UIContext.Provider value={{ setAlert, setSubdomain, subdomain }}>
      {children}
      <Dialog open={alert.isShown}>
        <Alert severity={alert.severity} onClose={handleClose}>
          <AlertTitle>{alert.message}</AlertTitle>
          {alert.description}
        </Alert>
      </Dialog>
    </UIContext.Provider>
  );
};
